import { t } from '@/locale/index.js'
import { applyPersonnelListLabels } from '@/utils/personnelListI18n.js'
import { applySearchLabels } from '@/utils/listPageI18n.js'

/** 系统用户列表（Personnel / bindUserList 等） */
export function applySystemPersonnelLabels({
  searchData,
  columns,
  employmentOptions,
  sexOptions,
  statusOptions,
  roleOptions,
  searchLabelKey = 'field.personnel',
}) {
  applyPersonnelListLabels({
    searchData,
    columns,
    employmentOptions,
    sexOptions,
    statusOptions,
    role: 'machinist',
  })
  if (searchData?.[0] && searchLabelKey) {
    searchData[0].label = t(searchLabelKey)
  }
  applySearchLabels(searchData, {
    role_id: { labelKey: 'field.role' },
    employment: { labelKey: 'field.employment' },
  })
  if (roleOptions?.length >= 5) {
    roleOptions[0].label = t('common.all')
    roleOptions[1].label = t('personnelDetail.tabMachinist')
    roleOptions[2].label = t('personnelDetail.tabCaptain')
    roleOptions[3].label = t('systemPersonnel.roleNormalAdmin')
    roleOptions[4].label = t('systemPersonnel.roleSuperAdmin')
  }
  if (employmentOptions?.length >= 3 && employmentOptions[0].value === 99) {
    employmentOptions[0].label = t('common.all')
  }
}

export { t }
